import React from 'react';
import ImageDropdownInput from './ImageDropdownInput'
import PropTypes from 'prop-types'
import ReactToPrint from 'react-to-print';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

class OptionsForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            style : 'style1',
        };
    }

    getStyles() {
        return [
            {value:"style1", imgSrc: process.env.PUBLIC_URL+"/images/style1/design1.jpg?ver="+window.settings.ver, imgAlt:"Style 1" },
            {value:"style2", imgSrc: process.env.PUBLIC_URL+"/images/style2/design2.jpg?ver="+window.settings.ver, imgAlt:"Style 2" },
            {value:"style3", imgSrc: process.env.PUBLIC_URL+"/images/style3/design3.jpg?ver="+window.settings.ver, imgAlt:"Style 3" },
        ]
    }

    handleStyleChange = (value) => {
        this.props.onChange({
            style: value
        })
        this.setState({
            style: value
        });
    }
    handleDstChange = (value) => {
        this.props.onChange({
            dst: value
        });
    }
    handleMethodChange = (value) => {
        this.props.onChange({
            method: value
        });
    }
    handleAsrMethodChange = (value) => {
        this.props.onChange({
            asrMethod: value
        });
    }
    

    render() {
        return (
            <Row>
                <Col md={2} sm={6} xs={12}>
                    <ImageDropdownInput text="Choose Design" options={this.getStyles()} selected={this.state.style} onChange={this.handleStyleChange} />
                </Col>
                <Col md={2} sm={6} xs={12}>
                    <Form.Group as={Row}>
                        <Form.Label column sm="3">DST:</Form.Label>
                        <Col sm="9">
                            <Form.Control as="select" onChange={e => this.handleDstChange(e.target.value)}>
                                <option value="0">Standard</option>
                                <option value="1">+1</option>
                                <option value="-1">-1</option>
                            </Form.Control>
                        </Col>
                    </Form.Group>
                </Col>
                <Col md={4} sm={12} xs={12}>
                    <Form.Group as={Row}>
                        <Form.Label column sm="4">Fajr and Isha Method:</Form.Label>
                        <Col sm="8">
                            <Form.Control as="select" onChange={e => this.handleMethodChange(e.target.value)}>
                                <option value="ISNA">Islamic Society of North America (ISNA)</option>
                                <option value="MWL">Muslim World League (MWL)</option>
                                <option value="Egypt">Egyptian General Authority of Survey</option>
                                <option value="Makkah">Umm al-Qura University, Makkah</option>
                                <option value="Karachi">University of Islamic Sciences, Karachi</option>
                                <option value="Jafari">Shia Ithna-Ashari (Jafari)</option>
                                <option value="Tehran">Institute of Geophysics, University of Tehran</option>
                            </Form.Control>
                        </Col>
                    </Form.Group>
                </Col>
                <Col md={3} sm={8} xs={12}>
                    <Form.Group as={Row}>
                        <Form.Label column sm="5">Asr Method:</Form.Label>
                        <Col sm="7">
                            <Form.Control as="select" onChange={e => this.handleAsrMethodChange(e.target.value)}>
                                <option value="Standard">Standard</option>
                                <option value="Hanafi">Hanafi</option>
                            </Form.Control>
                        </Col>
                    </Form.Group>
                </Col>
                <Col md={1} sm={4} xs={12}>
                <ReactToPrint
                    trigger={() => <button className={`btn btn-success ${this.props.disabled ? 'hidden' : ''}`}>Print</button>}
                    content={() => this.props.printTableRef.current}
                    />
                </Col>
            </Row>
        );
    }

}

OptionsForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    printTableRef: PropTypes.any.isRequired,
    disabled: PropTypes.bool.isRequired
}

export default OptionsForm;